export default {
  title: {
    text: "国内负极材料市场企业占比",
    left: "center",
    top: 20,
  },
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b} : ({d}%)",
  },
  visualMap: {
    show: false,
    min: 100,
    max: 3000,
    inRange: {
      colorLightness: [0.2, 0.8],
    },
  },
  series: [
    {
      name: "材料供应商",
      type: "pie",
      radius: "55%",
      center: ["50%", "60%"],
      data: [
        { value: 2240, name: "贝特瑞" },
        { value: 1797, name: "宁波杉杉" },
        { value: 1693, name: "江西紫宸" },
        { value: 1367, name: "东莞凯金" },
        { value: 573, name: "翔丰华" },
        { value: 563, name: "中科星城" },
        { value: 417, name: "江西正拓" },
        { value: 365, name: "深圳斯诺" },
        { value: 182, name: "深圳金润" },
        { value: 89, name: "长沙格翔" },
        { value: 716, name: "其他" },
      ].sort(function (a, b) {
        return a.value - b.value;
      }),
      roseType: "radius",
      label: {
        color: "#43c8f7",
      },
      labelLine: {
        lineStyle: {
          color: "#43c8f7",
        },
        smooth: 0.2,
        length: 10,
        length2: 20,
      },
      itemStyle: {
        color: "#43c8f7",
        shadowBlur: 200,
        shadowColor: "rgba(0, 0, 0, 0.5)",
      },

      animationType: "scale",
      animationEasing: "elasticOut",
      animationDelay: function (idx) {
        return Math.random() * 200;
      },
    },
  ],
};
